export const GENERATE_KEYWORDS_REQUEST   = 'GENERATE_KEYWORDS_REQUEST'
export const GENERATE_KEYWORDS_SUCCESS   = 'GENERATE_KEYWORDS_SUCCESS'
export const GENERATE_KEYWORDS_FAIL      = 'GENERATE_KEYWORDS_FAIL'
export const GENERATE_KEYWORDS_RESET     = 'GENERATE_KEYWORDS_RESET'